
import { TimelineSection as TimelineSectionType } from "@/types";
import { cn } from "@/lib/utils";
import TimelineSectionHeaderTitleBlock from "./TimelineSectionHeaderTitleBlock";
import TimelineSectionHeaderPeriodBlock from "./TimelineSectionHeaderPeriodBlock";
import TimelineLine from "./TimelineLine";

interface TimelineSectionHeaderProps {
  section: TimelineSectionType;
  isEven: boolean;
  yearFrom: number;
  yearTo: number;
  handleToggle: () => void;
  isExpanded: boolean;
  entriesCount?: number;
  onCreateMemory?: () => void;
}

const TimelineSectionHeader = ({ 
  section, 
  isEven, 
  yearFrom, 
  yearTo, 
  handleToggle,
  isExpanded,
  entriesCount = 0,
  onCreateMemory
}: TimelineSectionHeaderProps) => {
  return (
    <div className="flex w-full py-10 min-h-[200px] items-center relative">
      {/* Solid timeline line */}
      <TimelineLine variant="solid" />
      
      {/* Left column */}
      <div className={cn(
        "w-1/2 flex flex-col justify-center",
        isEven 
          ? "items-end" 
          : "items-start"
      )}>
        {isEven ? (
          <TimelineSectionHeaderTitleBlock 
            icon={section.icon}
            name={section.name}
            description={section.description}
            cosmicAspect={section.cosmic_aspect}
            align="right"
          />
        ) : (
          <TimelineSectionHeaderPeriodBlock
            yearFrom={yearFrom}
            yearTo={yearTo}
            handleToggle={handleToggle}
            isExpanded={isExpanded}
            align="left"
            entriesCount={entriesCount}
            onCreateMemory={onCreateMemory}
          />
        )}
      </div>
      
      {/* Right column */}
      <div className={cn(
        "w-1/2 flex flex-col justify-center",
        isEven 
          ? "items-end" 
          : "items-start"
      )}>
        {isEven ? (
          <TimelineSectionHeaderPeriodBlock
            yearFrom={yearFrom}
            yearTo={yearTo}
            handleToggle={handleToggle}
            isExpanded={isExpanded}
            align="right"
            entriesCount={entriesCount}
            onCreateMemory={onCreateMemory}
          />
        ) : (
          <TimelineSectionHeaderTitleBlock
            icon={section.icon}
            name={section.name}
            description={section.description}
            cosmicAspect={section.cosmic_aspect}
            align="left" 
          />
        )}
      </div>
    </div>
  );
};

export default TimelineSectionHeader;
